import { store } from '@/store';

const localRoutes = [];
if (/\.test$/.test(document.location.hostname)) {
   localRoutes.push({
      path: 'testpage',
      name: 'testpage',
      component: () => import('pages/TestPage'),
      meta: {
         title: 'Testpage',
         icon: 'mdi-bug',
      },
   });
}

const routes = [
   {
      path: '',
      component: () => import('layouts/BlankLayout'),
      children: [
         {
            path: '/',
            redirect: { name: 'companies' },
         },
         {
            name: 'login',
            path: '/login',
            component: () => import('pages/auth/LoginPage'),
            meta: {
               guest: true,
            },
         },
         {
            name: 'view-business-lead',
            path: '/vis-lead/erhverv/:uid',
            component: () => import('pages/ViewLeadPage.vue'),
            meta: {
               background: false,
               title: 'Vis lead',
            },
         },
      ],
   },
   {
      path: '/admin',
      component: () => import('layouts/MainLayout.vue'),
      children: [
         {
            name: 'home',
            path: '',
            component: () => import('pages/Home.vue'),
            meta: {
               title: 'Dashboard',
               icon: 'mdi-monitor-dashboard',
            },
         },
         {
            path: 'brancher',
            component: () => import('layouts/PassThrough'),
            children: [
               {
                  name: 'trades',
                  path: '',
                  component: () => import('pages/TradesPage.vue'),
                  meta: {
                     title: 'Brancher',
                     icon: 'mdi-briefcase',
                  },
               },
               {
                  name: 'trade',
                  path: 'detaljer/:code',
                  component: () => import('pages/TradePage.vue'),
               },
               {
                  name: 'trades.company',
                  path: ':slug',
                  component: () => import('pages/CompanyTradesPage.vue'),
               },
            ],
         },
         {
            path: 'selskaber',
            component: () => import('layouts/PassThrough'),
            children: [
               {
                  name: 'companies',
                  path: '',
                  component: () => import('pages/CompaniesPage.vue'),
                  meta: {
                     title: 'Selskaber',
                     fn: route => route.name,
                     icon: 'mdi-factory',
                  },
               },
               {
                  path: ':slug',
                  component: () => import('layouts/PassThrough'),
                  children: [
                     {
                        name: 'company',
                        path: '',
                        component: () => import('pages/CompanyPage.vue'),
                        meta: {
                           title: 'Selskab',
                           subtitle: route => {
                              const { slug } = route.params;
                              if (slug) {
                                 const company = store.getters['companies/findBySlug'](slug);
                                 return company ? company.name : slug;
                              }
                              return '';
                           },
                        },
                     },
                  ],
               },
            ],
         },
         {
            path: 'postnumre',
            component: () => import('layouts/PassThrough.vue'),
            children: [
               {
                  path: '',
                  name: 'zips',
                  component: () => import('pages/ZipsPage.vue'),
                  meta: {
                     icon: 'mdi-postage-stamp',
                     title: 'Postnumre',
                  },
               },
               {
                  name: 'zips.company',
                  path: ':slug',
                  component: () => import('pages/CompanyZipsPage.vue'),
               },
            ],
         },
         {
            path: 'leads',
            component: () => import('layouts/PassThrough.vue'),
            children: [
               {
                  name: 'business-lead-search',
                  path: 'soeg',
                  component: () => import('pages/BusinessLeadSearchPage.vue'),
                  meta: {
                     icon: 'mdi-table-search',
                     title: 'Lead tabel',
                  },
               },
               {
                  name: 'business-lead',
                  path: ':id?',
                  component: () => import('pages/BusinessLeadPage.vue'),
                  meta: {
                     icon: 'mdi-file-document-edit',
                     title: 'Lead detaljer',
                     subtitle: route => route.params.id || 'Søgning',
                  },
               },
            ],
         },
         {
            path: 'statistik',
            component: () => import('layouts/PassThrough.vue'),
            children: [
               {
                  name: 'stats.leads',
                  path: 'leads/:from?/:to?/:slug?',
                  component: () => import('pages/LeadStatsPage.vue'),
                  meta: {
                     title: 'Lead indhold',
                     subtitle: route => {
                        const { from, to, slug } = route.params;
                        if (!from) {
                           return 'Søg statistik';
                        }
                        let subtitle = `${from} - ${to}`;
                        if (slug) {
                           const company = store.getters['companies/findBySlug'](slug);
                           subtitle = `${company ? company.name : slug} ${subtitle}`;
                        }
                        return subtitle;
                     },
                     icon: 'mdi-calendar-search',
                  },
               },
               {
                  name: 'stats.deliveries',
                  path: 'leverancer/:from?/:to?/:slug?',
                  component: () => import('pages/DeliveryStatsPage.vue'),
                  meta: {
                     title: 'Leverancer',
                     icon: 'mdi-currency-usd',
                  },
               },
            ],
         },
         ...localRoutes,
      ],
   },
];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
   routes.push({
      path: '*',
      component: () => import('pages/Error404.vue'),
   });
}

export default routes;
